/**
 * @generated SignedSource<<a6d36c6f98334228946a4888872c5bb5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "walletId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "walletid",
        "variableName": "walletId"
      }
    ],
    "concreteType": "WalletLedgerSummary",
    "kind": "LinkedField",
    "name": "getwalletledgersummary",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetAndFullArBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetAndArBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetArAuthBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "authBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "floatBalanceForAuth",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomerWalletBalanceTilesQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CustomerWalletBalanceTilesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "39a23249e0107d829b2fe95e489ffe65",
    "id": null,
    "metadata": {},
    "name": "CustomerWalletBalanceTilesQuery",
    "operationKind": "query",
    "text": "query CustomerWalletBalanceTilesQuery(\n  $walletId: UUID!\n) {\n  getwalletledgersummary(walletid: $walletId) {\n    assetBalance\n    assetAndFullArBalance\n    assetAndArBalance\n    assetArAuthBalance\n    authBalance\n    floatBalanceForAuth\n  }\n}\n"
  }
};
})();

node.hash = "ff2d20d0aa0eecf74ec7cda96c09c886";

module.exports = node;
